<div class="row divider">
    <div class="col col-main-heading mb-1 d-lg-block d-none">
        <h3 class="mt-3 mb-2">{{ title }} ({{ model.length }})</h3>
    </div>
</div>
<ng-container *ngIf="model.length === 0">
    <div class="row not-found">
        <div class="col">
            <p>{{ strings.noNotificationsError }}</p>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="model.length > 0">
    <div class="row divider ps-1 ps-lg-0" *ngFor="let notification of notificationList">
        <pace-dashboard-notification
            class="cursor-pointer col position-relative"
            [ngClass]="getBorderClass(notification.effect)"
            [notification]="notification"
            [effectCodeIcon]="effectCodeIcon"
            [effectCodeIconColorClass]="effectCodeIconColorClass"
        ></pace-dashboard-notification>
    </div>
</ng-container>
